import { EDUCATION_SPECIALIST_ID, SOFTWARE_ENGINEER_ID } from '../../employee/position/positionService';
import { ENGLISH_ID, type Technology } from './technologyService';

export type TechnologyFilterFunction = (technologies: Technology[]) => Dictionary<string>;

export const TECHNOLOGY_REQUIRED_POSITION_IDS = [SOFTWARE_ENGINEER_ID, EDUCATION_SPECIALIST_ID] as const;

const technologyRequiredPositionIds = new Set(TECHNOLOGY_REQUIRED_POSITION_IDS.map(String));

export const isTechnologyRequired = (positionId?: string | number | null): boolean =>
  positionId != null && technologyRequiredPositionIds.has(String(positionId));

const createTechnologyFilter = (positionId: string | number): TechnologyFilterFunction => {
  const positionIdStr = String(positionId);

  switch (positionIdStr) {
    case String(EDUCATION_SPECIALIST_ID):
      return (technologies: Technology[]) => {
        const english = technologies.find(item => item.id === ENGLISH_ID);
        return english ? { [english.id]: english.name } : {};
      };

    case String(SOFTWARE_ENGINEER_ID):
      return (technologies: Technology[]) => {
        return technologies
          .filter(technology => technology.id !== ENGLISH_ID)
          .reduce(
            (result, technology) => ({
              ...result,
              [technology.id]: technology.name,
            }),
            {},
          );
      };

    default:
      return (technologies: Technology[]) => {
        return technologies.reduce(
          (result, technology) => ({
            ...result,
            [technology.id]: technology.name,
          }),
          {},
        );
      };
  }
};

export const getTechnologyFilter = (positionId?: string | number): TechnologyFilterFunction | undefined => {
  if (!positionId) {
    return undefined;
  }

  return createTechnologyFilter(positionId);
};
